import { configureStore } from "@reduxjs/toolkit";
import profileReducer from "./profileSlice";

const store = configureStore({
  reducer: {
    profile: profileReducer,
    // Add other reducers here
  },
});

export default store;
